export abstract class AbstractSessionService {
  abstract logout(): Promise<void>;

  /**
   * Returns whether the FedNow Transaction Dual Approval Workflow configuration should be
   * allowed to be displayed to the logged on user (if they have entitlements to configure FedNow).
   */
  abstract getFedNowTransactionDualApprovalWorkflowConfigEnabled(): Promise<boolean | undefined>;
}
